import each from './each';
import isArray from './is-array';
import isNil from './is-nil';
export default (function (data, name) {
  var rst = [];
  var tmpMap = {};
  data.forEach(function (obj) {
    var value = obj[name];

    if (!isNil(value)) {
      // flatten
      if (!isArray(value)) {
        value = [value];
      }

      each(value, function (val) {
        // unique
        if (!tmpMap[val]) {
          rst.push(val);
          tmpMap[val] = true;
        }
      });
    }
  });
  return rst;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/values-of-key.js
// module id = 46
// module chunks = 0